import React from 'react'

class LinijaComponent extends React.Component {
    render() {
        return <div  className="linijaContent">
        <iframe  allowfullscreen="" frameborder="0" height="315" width="420" src="https://www.youtube.com/embed/rHkMjCc0SAE"></iframe>
        <div  className="linijaText">     
    
            <p ><b >Automatinė fasavimo linija</b> 1-30 Kg</p>
            <p >Našumas priklausomai nuo fasuojamo paketo dydžio ir žaliavos
               Fasuojant granules po 15 kg – našumas iki 4000 kg</p>
            <p ><b >Pusiau automatinė fasavimo įranga</b> 5-25 Kg</p>  
            <p ><b >Rankinė fasavimo įranga</b></p>  
     
          
        </div>
    
    </div>
    }
}

export default LinijaComponent